import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Navbar, Label } from "reactstrap";
import lscache from "lscache";

import { Link, Redirect } from "react-router-dom";
import { IconeSetaEsquerda } from "../components/Icones";
import TopBarHeader from "../components/TopBarHeader";
import BarraNotificacoes from "../components/BarraNotificacoes";

@inject("store")
@observer
export default class TopBar extends Component {
  constructor(props) {
    super(props);
    this.appStore = this.props.store.appStore;
    this.loginStore = this.props.store.loginStore;
    this.mensagemOcupacaoTecon = ""
    this.mensagemOcupacaoDepot = ""
  }

     componentDidMount() {
        this.loginStore.RecuperaOcupacaoPatio();
     }

     
     
  renderStatusIndicatorTecon(status) {
    let color;

    switch (status) {
      case "OK":
        color = "#28a745"; // Verde
        this.mensagemOcupacaoTecon = "Operação normal, sem impactos no atendimento."
        break;
      case "MEDIO":
        color = "#ffc107"; // Amarelo
        this.mensagemOcupacaoTecon = "Atenção: pequenas variações nos tempos de atendimento podem ocorrer."
        break;
      case "ALTO":
        color = "#dc3545"; // Vermelho
         this.mensagemOcupacaoTecon = "Alta probabilidade de atrasos. Equipes mobilizadas para reduzir impactos."
        break;
      default:
        color = "#6c757d"; // Cinza (status desconhecido)
    }

    const style = {
      width: '16px',
      height: '16px',
      borderRadius: '50%',
      backgroundColor: color,
      display: 'inline-block',
      border: '1px solid #000',
      marginLeft: '6px', // cria espaço entre o botão e a bolinha
      marginRight: '6px'
    };
    return <span title={this.mensagemOcupacaoTecon || status} style={style}></span>;
  }
  renderStatusIndicatorDepot(status) {
    let color;

    switch (status) {
      case "OK":
        color = "#28a745"; // Verde
        this.mensagemOcupacaoDepot = "Operação normal, sem impactos nas janelas de atendimento."
        break;
      case "MEDIO":
        color = "#ffc107"; // Amarelo
        this.mensagemOcupacaoDepot = " Atenção: Operando com janelas reduzidas parcialmente para a entrega de containers"
        break;
      case "ALTO":
        color = "#dc3545"; // Vermelho
         this.mensagemOcupacaoDepot = "Operando com janelas reduzidas para entrega de containers"
        break;
      default:
        color = "#6c757d"; // Cinza (status desconhecido)
    }

    const style = {
      width: '16px',
      height: '16px',
      borderRadius: '50%',
      backgroundColor: color,
      display: 'inline-block',
      border: '1px solid #000',
      marginLeft: '6px', // cria espaço entre o botão e a bolinha
      marginRight: '6px'
    };
    return <span title={this.mensagemOcupacaoDepot || status} style={style}></span>;
  }

  quit() {
    lscache.flush();
    /*TODO - Descobrir pq com o comando antigo, não está mais fazendo logout ao clicar em sair
    Site só desconecta no segundo comando "Sair" seguido - repeti o comando pra tirar esse bug chatinho*/
    lscache.flush();
    window.location.href = "/login";
    this.loginStore.logout();
  }

  render() {
    let voltar;
    if (this.appStore.topbarVoltarParams !== null) {
      voltar = (
        <Link
          className="link"
          to={{
            pathname: this.appStore.topbarVoltarLink,
            state: this.appStore.topbarVoltarParams.state,
          }}
        >
          <Label>
            <a
              onClick={this.appStore.topbarVoltarClick}
              href={this.appStore.topbarVoltarLink}
            >
              <IconeSetaEsquerda /> VOLTAR
            </a>
          </Label>
        </Link>
      );
    } else {
      if (this.appStore.topbarVoltarLink !== null)
        voltar = (
          <Link to={this.appStore.topbarVoltarLink}>
            <IconeSetaEsquerda />{" "}
            <Label
              onClick={this.appStore.topbarVoltarClick}
              className="btn-primary"
            >
              VOLTAR
            </Label>
          </Link>
        );
      else
        voltar = (
          <Label
            onClick={this.appStore.topbarVoltarClick}
            className="btn-primary"
          >
            <IconeSetaEsquerda style={{ marginRight: 5 }} />
            VOLTAR
          </Label>
        );
    }

    return (
      <div
        className={`topbar ${
          !this.appStore.topbarVisivel ? "hide-topbar" : ""
        }`}
      >
        <Navbar>

          <span
            className={`topbar--link ${
              this.appStore.sidebarFechado
                ? "topbar--link__fechado"
                : "topbar--link__aberto"
            }`}
          >
            {this.props.children}
          </span>
          {this.appStore.topbarVoltarVisivel && (
            <span
              className={`${
                this.appStore.sidebarFechado
                  ? "span-voltar-sidebar-fechado"
                  : "span-voltar-sidebar-aberto"
              }`}
            >
              <div>{voltar}</div>
            </span>
          )}
          {
            <span
              className={`${
                this.appStore.sidebarFechado
                  ? this.appStore.topbarVoltarVisivel
                    ? "span-notificacoes-sidebar-fechado-voltar"
                    : "span-notificacoes-sidebar-fechado"
                  : this.appStore.topbarVoltarVisivel
                  ? "span-notificacoes-sidebar-aberto-voltar"
                  : "span-notificacoes-sidebar-aberto"
              }`}
            >
              <BarraNotificacoes controller={this.loginStore} />
               {this.loginStore.iconeAtivo && <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
               <span style={{ fontWeight: 'bold', marginRight: '1px', marginLeft: '1px',textTransform: 'uppercase' }}>Ocupação Depot:</span>
               { this.renderStatusIndicatorDepot(this.loginStore.ocupacaoDepot) }
               <span style={{ fontWeight: 'bold', marginRight: '1px', marginLeft: '5px',textTransform: 'uppercase' }}>Ocupação Tecon:</span>
               { this.renderStatusIndicatorTecon(this.loginStore.ocupacaoTecon) }

             </div>  } 
            </span>
          }
          {this.props.exibeSair && (
           <span className="topbar--logout">
           <TopBarHeader logout={this.quit} controller={this.loginStore} />
         </span>
          )}
        </Navbar>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/TopBar.js